import { createAsyncThunk } from '@reduxjs/toolkit';
import { Middleware } from 'redux';
import { ApplicationState } from '../store';
import { AppDispatch } from '../store';
import axios from "axios";

import { predictionsActions } from '../actions/predictions.actions';
import { IEvent } from '../../Types/Event';
import { IResource } from '../../Types/Resource';

import { REACT_APP_FIELDS_URL } from '../../AppConfig';
import { translateEvents } from './predictions.event.tranlator';
import { translateRawData } from './predictions.rawdata.translator';
import { computeToResource } from './predictions.resource.translator';


export const fetchAllPredictions = createAsyncThunk<
  IEvent[],
  string,
  {
    // Optional fields for defining thunkApi field types
    dispatch: AppDispatch
    state: ApplicationState
    extra: {
      jwt: string
    }
    requestId: string
    signal: AbortSignal
  }>(
    'predictions/fetchAllPredictions',
    async (placeholder, thunkApi) => {
      thunkApi.dispatch(predictionsActions.loadingStart);
      
      const token = thunkApi.getState().security.token;
      const fields = thunkApi.getState().fields.fields;

      let events: IEvent[] = [];
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      };

      await axios.get(
        REACT_APP_FIELDS_URL + 'v1/predictions'
        , config
      )
        .then((response) => {
          console.log(REACT_APP_FIELDS_URL + 'v1/predictions')
          if (response.data != null) {
            events = translateEvents(response.data);
            const resources: IResource[] = computeToResource(events, fields);
            thunkApi.dispatch(predictionsActions.replaceResources(resources));
            thunkApi.dispatch(predictionsActions.replaceRawData(translateRawData(response.data)));
          }
        })
        .catch(error => {
          console.log(error);
        });

      thunkApi.dispatch(predictionsActions.loadingFinished);
      return events;
    }
  );


  // export const calculateResources = createAsyncThunk<
  // IResource[],
  // string,
  // {
  //   // Optional fields for defining thunkApi field types
  //   dispatch: AppDispatch
  //   state: ApplicationState
  //   extra: {
  //     jwt: string
  //   }
  // }>(
  //   'predictions/calculateResources',
  //   async (placeholder, thunkApi) => {
  //     thunkApi.dispatch(predictionsActions.loadingStart);

  //     const resources: IResource[] = computeToResource(thunkApi.getState().predictions.events);
  //     thunkApi.dispatch(predictionsActions.loadingFinished);
  //     return resources;
  //   }
  // );

  const predictions: Middleware = store => next => action => {
    let result = next(action)
    if (action.type === predictionsActions.replacePredictions.type) {
      fetchAllPredictions(store.getState());
    } 
    // else if (action.type === predictionsActions.replaceResources.type) {
    //   calculateResources(store.getState());
    // }
  
    return result
  }
  
  export default predictions;